import React from "react";
import { motion } from "framer-motion";

const countries = [
  { flag: "🇬🇧", name: "United Kingdom" },
  { flag: "🇲🇨", name: "Monaco" },
  { flag: "🇨🇭", name: "Switzerland" },
  { flag: "🇸🇬", name: "Singapore" },
  { flag: "🇦🇪", name: "United Arab Emirates" },
];

export default function InternationalExperience() {
  return (
    <section id="international" className="py-28 sm:py-36 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Global Perspective</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">International Experience</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {countries.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white border border-gray-100 rounded-3xl p-7 flex flex-col items-center text-center gold-glow"
              data-testid={`country-${i}`}
            >
              <span className="text-4xl mb-4" aria-hidden="true">{c.flag}</span>
              <p className="font-display text-lg font-bold leading-tight">{c.name}</p>
            </motion.div>
          ))}
        </div>

        <p className="text-center text-gray-600 mt-12 max-w-2xl mx-auto text-[15px] sm:text-base leading-relaxed">
          Drawing upon experience across international banking, finance and diverse business environments.
        </p>
      </div>
    </section>
  );
}
